







































import getCraftPages from '~/queries/craft-pages.gql'
import getRelatedPosts from '~/queries/related-posts.gql'
import pageMixin from '@bkwld/cloak/mixins/page'
import { makeJsonLdArticleTag } from '@bkwld/json-ld-formatters'

export default
	name: 'Article'

	mixins: [ pageMixin ]

	# Structured meta
	head: -> {
		...@buildHead
			image: (image = @$makeImgixUrl @page.listingImage[0]?.path)
		script: [ makeJsonLdArticleTag
			title: @page.title
			image: image
			publishedAt: new Date @page.dateCreated
			updatedAt: new Date @page.dateUpdated
			author: "California Olive Ranch"
		]
	}

	# Get Tower data
	asyncData: ({ app, store, route, payload }) ->
		# Get data
		[ page ] = payload || await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'articles'
				uri: route.path.substr(1)
		return app.$notFound() unless page

		# Get 3 other blogs besides the current blog
		relatedPosts = await app.$craft.getEntries
			query: getRelatedPosts
			variables:
				section: 'articles'
				exclude: page?.id
				category: page?.category?[0]?.id

		# Set data
		return { page, relatedPosts }

	computed:
		# simulate the data for the
		# standard marquee block
		standardMarqueeBlock: ->
			copy: "<h1 class=\"style-h1\">#{@page.title}</h1>"
			breadcrumbAlign: 'left'
			backgroundImage: if @mainCategory then @mainCategory.image else [
				{
					landscape: @page.listingImage
				}
			]
			breadcrumbs: @breadcrumbLinks

		mainCategory: -> @page?.category?[0]

		hasCategory: -> !!@page?.category?.length

		breadcrumbLinks: -> [
			{
				text: "Articles"
				href: "/articles"
			}
			{
				text: @mainCategory?.title
				href: "/articles/#{@mainCategory?.slug}"
			} if @mainCategory
		] if @hasCategory

		bodyBlock: ->
			body: @page.body

		# Category Id for featured section
		relatedProductsBlock: ->
			categories: [ {"id": '23091'} ]
			products: []

		relatedPostsCards: ->
			@relatedPosts.map (post) ->
				image: post.listingImage
				eyebrow: post.category?[0]?.title
				title: post.title
				href: "/#{post.uri}"
				layout: 'text-on-bottom'

		relatedArticlesBlock: ->
			cards: @relatedPostsCards


